import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "../redux/slices/authSlice";
import teamMemberReducer from "../redux/slices/teamMemberSlice";
import organCategoryReducer from "../redux/slices/organCategorySlice";
import donorReviewReducer from "../redux/slices/donorReviewSlice";
import blogReducer from "../redux/slices/blogsSlice";
import dataCountReducer from "../redux/slices/dataCountSlice";
import eventCategoryReducer from "../redux/slices/eventCategorySlice";
import pressCategoryReducer from "../redux/slices/pressCategorySlice";
import photoGalleryReducer from "../redux/slices/photoGallerySlice";
import videoSectionReducer from "../redux/slices/videoSectionSlice";
import electricMediaReducer from "../redux/slices/electricMediaSlice";
import digitalMediaReducer from "../redux/slices/digitalMediaSlice";
import donorApplicationReducer from "../redux/slices/donorApplication";
import paymentReducer from "../redux/slices/paymentSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  dataCount: dataCountReducer,
  teamMember: teamMemberReducer,
  organCategory: organCategoryReducer,
  donorReview: donorReviewReducer,
  blogs: blogReducer,
  eventCategory: eventCategoryReducer,
  pressCategory: pressCategoryReducer,
  photoGallery: photoGalleryReducer,
  videoSection: videoSectionReducer,
  electricMedia: electricMediaReducer,
  digitalMedia: digitalMediaReducer,
  donorApplication: donorApplicationReducer,
  payment: paymentReducer,
});

export default rootReducer;
